import { factory, getResponseCamelization } from '@repo-level/core-front';
import { CMS_URL, isCMSV3 } from 'helpers/conf';
import type { CMSApiBase, CMSImageBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface CMSGameCover extends CMSApiBase {
  gameId: string;
  cover: CMSImageBase;
}

const GAME_COVERS_LIMIT = 3000;

export const gameCoversV3 = factory(
  (r) => () =>
    r<CMSGameCover[]>(
      'get',
      `${CMS_URL}/game-covers?_limit=${GAME_COVERS_LIMIT}`
    )
);

export const gameCoversV4 = factory(
  (r) => () =>
    r<CMSGameCover[]>(
      'get',
      buildCmsUrl({
        path: 'game-covers',
        limit: GAME_COVERS_LIMIT,
        additionalParams: {
          populate: 'deep',
        },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const gameCovers = isCMSV3 ? gameCoversV3 : gameCoversV4;
